/**
 * Users Routes
 */
import { Layout, Section } from 'layout';
import { Redirect, Route, Switch } from 'react-router-dom';

// async components
import { AsyncStatisticsComponent } from 'components/AsyncComponent';

const Forms = ({ match }) => {
  return (
    <Layout type={'sidebar_page_layout'}>
      <Section name={'content'}>
        <Switch>
          <Route path={`${match.url}`} component={AsyncStatisticsComponent} />
          <Route path='*' render={() => <Redirect to='/404' />} />
        </Switch>
      </Section>
    </Layout>
  );
};

export default Forms;
